import { Injectable, Output, EventEmitter } from '@angular/core';
import * as dayjs from 'dayjs';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-timezone';
import { constant } from 'src/app/common/constant';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  @Output() adminName: EventEmitter<any> = new EventEmitter();
  @Output() translateNewLanguage: EventEmitter<any> = new EventEmitter();
  public productId: any;
  brewerDetails = {};
  constructor(
    private toastr: ToastrService
  ) { }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  /* THis function convert date in Year/Month/Day */

  convertDateFormat(str) {
    if (typeof str === 'object') {
      return dayjs(str).format('YYYY-MM-DD');
    }
    const isValidDate = str.toString().includes('-');
    if (!isValidDate) {
      return dayjs(str).format('YYYY-MM-DD');
    }
    str = str.split('-').reverse().join('-');
    return dayjs(str).format('YYYY-MM-DD');
  }

  /* THis function convert date in Day/Month/Year */

  convertDate(str) {
    return dayjs(str).format('DD-MM-YYYY');
  }
  convertToCurrentTimezone(date: string) {
    const newDate = moment.utc(date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format(constant.FORMAT);
    return date ? new Date(newDate.replace(/\s/g, 'T')) : new Date();
  }

  convertToBrowserTimezone(date: string) {
    return moment.utc(date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format(constant.FORMAT);
  }

  languageChange(): void {
    this.translateNewLanguage.emit();
  }

  getFormattedDate(date: string) {
    return dayjs(date).format('YYYY-MM-DD');
  }

  showSuccessToast(msg) {
    this.toastr.success(msg, 'Success');
  }

  showErrorToast(msg) {
    this.toastr.error(msg);
  }

  updateAdminName() {
    this.adminName.emit();
  }

  oneOptionToSelect(list: any[], key) {
    try {
      if (list.length > 0) {
        return list[0][key];
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  }
 
}
